import HistoryPostsMain from "../../component/Member/components/HistoryPosts/HistoryPostsMain";
import NavBar from "../../component/NavBar/NavBar";

function HistoryPosts() {
    return (
        <>
            <NavBar />
            <HistoryPostsMain />
        </>
    );
}

export default HistoryPosts;